var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWdl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M275.248 324.423H230.217V178.5H277.243C291.399 178.5 303.511 181.422 313.582 187.264C323.652 193.059 331.371 201.396 336.738 212.273C342.106 223.104 344.79 236.071 344.79 251.177C344.79 266.377 342.082 279.463 336.667 290.436C331.252 301.361 323.367 309.769 313.012 315.659C302.656 321.502 290.069 324.423 275.248 324.423ZM247.888 308.748H274.108C286.174 308.748 296.173 306.42 304.105 301.765C312.038 297.11 317.952 290.484 321.847 281.886C325.742 273.288 327.689 263.052 327.689 251.177C327.689 239.396 325.766 229.255 321.918 220.752C318.07 212.202 312.323 205.647 304.675 201.087C297.028 196.479 287.504 194.176 276.103 194.176H247.888V308.748Z",
    fill: "#008ffb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9008 227.923L20 82H37.9554L68.451 200.847H69.876L100.942 82H120.892L151.958 200.847H153.383L183.878 82H201.834L161.933 227.923H143.692L111.487 111.641H110.347L78.1412 227.923H59.9008Z",
    fill: "#008ffb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M406.498 430V284.077H424.168V414.325H491.999V430H406.498Z",
    fill: "#008ffb"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWdl);
export default __webpack_public_path__ + "static/media/wdl.7b11ddb60c0b0fcc270a8718a89447a3.svg";
export { ForwardRef as ReactComponent };